'use client';

import { Toaster } from 'sonner';

export default function ToastProvider() {
  return (
    <Toaster data-component-id="src/components/ToastProvider.tsx:7:4" data-component-path="src/components/ToastProvider.tsx" data-component-line="7" data-component-end-line="82" data-component-file="ToastProvider.tsx" data-component-name="Toaster" data-component-content="%7B%22elementName%22%3A%22Toaster%22%7D"
      position="bottom-right"
      toastOptions={{
        style: {
          background: '#151B26',
          border: '1px solid rgba(51,65,85,0.7)',
          color: '#E2E8F0',
          borderRadius: 14,
          fontFamily: 'Outfit, sans-serif',
          fontSize: '0.875rem',
          backdropFilter: 'blur(12px)',
        },
        classNames: {
          toast: 'elevate-toast',
        },
      }}
      icons={{
        success: (
          <span data-component-id="src/components/ToastProvider.tsx:25:10" data-component-path="src/components/ToastProvider.tsx" data-component-line="25" data-component-end-line="41" data-component-file="ToastProvider.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%9C%93%22%7D"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 20,
              height: 20,
              borderRadius: '50%',
              background: 'rgba(212,175,55,0.15)',
              border: '1px solid rgba(212,175,55,0.4)',
              color: '#D4AF37',
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            ✓
          </span>
        ),
        error: (
          <span data-component-id="src/components/ToastProvider.tsx:44:10" data-component-path="src/components/ToastProvider.tsx" data-component-line="44" data-component-end-line="60" data-component-file="ToastProvider.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22%E2%9C%95%22%7D"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 20,
              height: 20,
              borderRadius: '50%',
              background: 'rgba(239,68,68,0.15)',
              border: '1px solid rgba(239,68,68,0.4)',
              color: '#EF4444',
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            ✕
          </span>
        ),
        info: (
          <span data-component-id="src/components/ToastProvider.tsx:63:10" data-component-path="src/components/ToastProvider.tsx" data-component-line="63" data-component-end-line="79" data-component-file="ToastProvider.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22i%22%7D"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 20,
              height: 20,
              borderRadius: '50%',
              background: 'rgba(124,255,238,0.12)',
              border: '1px solid rgba(124,255,238,0.35)',
              color: '#7CFFEE',
              fontSize: 11,
              fontWeight: 700,
            }}
          >
            i
          </span>
        ),
      }}
    />
  );
}

/**
 * Convenience wrappers with brand colours.
 * Usage:
 *   import { toast } from '@/components/ToastProvider';
 *   toast.success('Article approved!');
 *   toast.info('Syncing knowledge base…');
 *   toast.error('Failed to save changes.');
 */
export { toast } from 'sonner';
